import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { selectIsAdmin, selectIsOperator } from "@/store/userSlice";

const AdminGuard = ({ children }) => {
  const isAdmin = useSelector(selectIsAdmin);
  const isOperator = useSelector(selectIsOperator);

  if (!isAdmin && !isOperator) {
    return <Navigate to="/no-access" replace />;
  }

  return children;
};

export default AdminGuard;